module.exports = __webpack_public_path__ + "static/media/21-1.1123a309.mp3";